module.exports = __webpack_public_path__ + "img/spare_part_heap_small.caac08fc.png";